import React from "react";
import { Box, Container, Stack, Typography, Button } from "@mui/material";
import Iconify from "../../components/Iconify";
import Reveal from "../../components/Reveal";
import PaymentRunAnimation from "../../components/PaymentRunAnimation";
import { INK, ACCENT, BeltStripe, ctaGlowSx } from "../../theme/brand";
import { REGISTER_URL } from "../../config";
import { TRUST_POINTS } from "./content";

// Der Ablauf in drei Worten statt eines erklärenden Absatzes – zeigt, wie
// einfach die Abbuchung geworden ist, statt es zu behaupten.
const FLOW = ["Vorschau", "Bestätigt", "Abgebucht"];

export default function Hero() {
  return (
    <Box
      sx={{
        bgcolor: INK,
        color: "#fff",
        position: "relative",
        overflow: "hidden",
      }}
    >
      <Box
        sx={{
          position: "absolute",
          top: "-30%",
          left: "50%",
          transform: "translateX(-50%)",
          width: 1100,
          height: 560,
          background:
            "radial-gradient(ellipse at center, rgba(91,79,212,0.28) 0%, transparent 70%)",
          pointerEvents: "none",
        }}
      />

      <Container
        maxWidth="lg"
        sx={{
          position: "relative",
          pt: { xs: 7, md: 11 },
          pb: { xs: 8, md: 10 },
        }}
      >
        <Stack
          direction={{ xs: "column", md: "row" }}
          spacing={{ xs: 5, md: 4 }}
          alignItems="center"
        >
          <Box sx={{ flex: 1, textAlign: { xs: "center", md: "left" } }}>
            <Typography
              variant="overline"
              sx={{ color: ACCENT, fontWeight: 700, letterSpacing: 2 }}
            >
              Software für Kampfsportschulen
            </Typography>

            <Typography
              variant="h1"
              sx={{
                fontWeight: 800,
                fontSize: { xs: 36, md: 54 },
                lineHeight: 1.1,
                letterSpacing: "-0.02em",
                mt: 1.5,
                mb: 3,
              }}
            >
              Mehr Zeit auf der{" "}
              <Box component="span" sx={{ color: ACCENT }}>
                Matte
              </Box>
              .
              <br />
              Weniger Zeit im Büro.
            </Typography>

            {/* Drei Worte statt eines Absatzes: zeigt den neuen Ablauf, statt ihn zu erklären. */}
            {/* <Stack
              direction="row"
              spacing={{ xs: 0.75, sm: 1.5 }}
              alignItems="center"
              justifyContent={{ xs: "center", md: "flex-start" }}
              flexWrap="wrap"
              sx={{ mb: 4 }}
            >
              {FLOW.map((word, i) => (
                <React.Fragment key={word}>
                  <Typography
                    sx={{
                      fontWeight: 700,
                      fontSize: { xs: 15, md: 17 },
                      color: i === FLOW.length - 1 ? ACCENT : "rgba(255,255,255,0.85)",
                    }}
                  >
                    {word}
                  </Typography>
                  {i < FLOW.length - 1 && (
                    <Iconify
                      icon="mdi:arrow-right"
                      width={16}
                      sx={{ color: "rgba(255,255,255,0.3)" }}
                    />
                  )}
                </React.Fragment>
              ))}
              <Typography
                sx={{ color: "rgba(255,255,255,0.45)", fontSize: { xs: 15, md: 17 } }}
              >
                – ganz ohne SEPA-Datei.
              </Typography>
            </Stack> */}

            <Stack
              direction={{ xs: "column", sm: "row" }}
              spacing={{ xs: 2, sm: 3.5 }}
              alignItems="center"
              justifyContent={{ xs: "center", md: "flex-start" }}
              sx={{
                maxWidth: { xs: 340, sm: "none" },
                mx: { xs: "auto", md: 0 },
              }}
            >
              <Button
                href={REGISTER_URL}
                variant="contained"
                size="large"
                sx={{
                  px: 4,
                  py: 1.5,
                  fontWeight: 700,
                  width: { xs: "100%", sm: "auto" },
                  ...ctaGlowSx,
                }}
              >
                1 Monat kostenlos testen
              </Button>
              <Box
                component="a"
                href="#funktionen"
                sx={{
                  position: "relative",
                  display: "inline-flex",
                  alignItems: "center",
                  gap: 0.5,
                  fontSize: 15,
                  fontWeight: 700,
                  color: "#fff",
                  "&::after": {
                    content: '""',
                    position: "absolute",
                    left: 0,
                    right: 0,
                    bottom: -2,
                    borderTop: "2px solid",
                    borderColor: ACCENT,
                    opacity: 0.5,
                    transition: "opacity 160ms ease",
                  },
                  "&:hover::after": { opacity: 1 },
                }}
              >
                Funktionen ansehen
              </Box>
            </Stack>

            <Stack
              direction="row"
              spacing={{ xs: 2, sm: 3 }}
              alignItems="center"
              justifyContent={{ xs: "center", md: "flex-start" }}
              flexWrap="wrap"
              sx={{ mt: 3 }}
            >
              {TRUST_POINTS.map((point) => (
                <Stack
                  key={point.text}
                  direction="row"
                  spacing={0.75}
                  alignItems="center"
                >
                  <Iconify
                    icon={point.icon}
                    width={16}
                    sx={{ color: ACCENT, flexShrink: 0 }}
                  />
                  <Typography
                    sx={{
                      fontSize: 13,
                      fontWeight: 600,
                      color: "rgba(255,255,255,0.55)",
                    }}
                  >
                    {point.text}
                  </Typography>
                </Stack>
              ))}
            </Stack>
          </Box>

          <Reveal
            delay={120}
            sx={{
              flex: 1,
              display: "flex",
              justifyContent: "center",
              width: "100%",
            }}
          >
            <PaymentRunAnimation />
          </Reveal>
        </Stack>
      </Container>

      <BeltStripe />
    </Box>
  );
}
